// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('carrier', {
//         templateUrl: 'views/components/views/carrier/carrier.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'modalService', 'carrierService', 'typeaheadService', 'translateService', function ($stateParams, stateService, modalService, carrierService, typeaheadService, translateService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let carrierKeyno = $stateParams.carrier_keyno;

//             let translations = {
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 prodIdButtons: [
//                     { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => goToFunc('product') }
//                 ],
//                 edit: {},
//                 lockedSave: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION FUNCTION

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION FUNCTION

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadEdit() {
//                 vm.model.edit = (await carrierService.getCarrier({ carrier_keyno: carrierKeyno }))[0];
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region MULTI DIRECTION FUNCTION

//             function goToFunc(state) {
//                 switch (state) {
//                     case 'product':
//                         carrierService.saveObj(vm.model.edit).then(function (response) {
//                             if (response[0].errorcode !== '0') {
//                                 modalService.show({
//                                     type: 'warning',
//                                     title: translations.error,
//                                     message: response[0].errormessage,
//                                     buttons: [{
//                                         label: translations.ok,
//                                         cssClass: 'btn-warning',
//                                         action: function (dialogItself) {
//                                             dialogItself.close();
//                                         }
//                                     }]
//                                 });
//                             } else {
//                                 stateService.go(state, { prod_id: vm.model.edit.prod_id });
//                             }
//                         });
//                         break;
//                     default:
//                         break;
//                 }
//             }

//             // #endregion MULTI DIRECTION FUNCTION

//             // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//             vm.typeaheadSearch = function (value, id) {
//                 switch (id) {
//                     case 'prod_name':
//                         vm.model.edit[id] = value;

//                         return typeaheadService.searchProduct({ prod_name: vm.model.edit[id] || '' });
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//             // #region SELECTED VALUE FUNCTION

//             vm.onTypeaheadSelected = function (item, id) {
//                 switch (id) {
//                     case 'prod_name':
//                         if (item) {
//                             vm.model.edit.prod_id = item?.item_id ?? '';
//                             vm.model.edit.prod_name = item?.item_name ?? '';
//                         } else {
//                             vm.onTypeaheadClear('prod_name');
//                         }
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion SELECTED VALUE FUNCTION

//             // #region CHANGED VALUE FUNCTION

//             vm.onTypeaheadChanged = function (value, item, id) {
//                 switch (id) {
//                     case 'prod_name':
//                         vm.model.edit.prod_name = value;

//                         if (value) {
//                             if (item?.item_id) {
//                                 vm.model.edit.prod_id = item.item_id;
//                             }
//                         } else {
//                             vm.onTypeaheadClear('prod_name');
//                         }
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion CHANGED VALUE FUNCTION

//             // #region CLEAR VALUE FUNCTION

//             vm.onTypeaheadClear = function (id) {
//                 switch (id) {
//                     case 'prod_name':
//                         vm.model.edit.prod_id = '';
//                         vm.model.edit.prod_name = '';
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion CLEAR VALUE FUNCTION

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 carrierService.saveObj(vm.model.edit).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                     	modalService.show({
//                     		type: 'warning',
//                             title: translations.error,
//                             message: response[0].errormessage,
//                             buttons: [{
//                                 label: translations.ok,
//                     			cssClass: 'btn-warning',
//                     			action: function (dialogItself) {
//                     				dialogItself.close();
//                     				vm.model.lockedSave = false;
//                     			}
//                     		}]
//                     	});
//                     } else {
//                     	vm.model.lockedSave = false;
//                     	stateService.back();		
//                     }
//                 });
//             };

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = function () {
//                 translate();
//                 loadEdit();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
